<template>
  <div>
    <div
      class="companyHeader"
      :style="{ backgroundImage: `url(${headerImg})` }"
    >
      <h1 class="heading-primary text-center" :style="{ color: textColor }">
        {{ h1Content }}
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    h1Content: {
      type: String,
      require: true
    }
  },
  data () {
    return {
      headers: {
        AkSigorta: {
          image: require('@/assets/company-pages/ak-sigorta.jpg')
        },
        AllianzSigorta: {
          image: require('@/assets/company-pages/allianz-sigorta.jpg')
        },
        SompoSigorta: {
          image: require('@/assets/company-pages/sompo-sigorta.jpg')
        },
        TurkNipponSigorta: {
          image: require('@/assets/company-pages/turk-nippon-sigorta.jpg')
        },
        TurkiyeSigorta: {
          image: require('@/assets/company-pages/turkiye-sigorta.jpg')
        },
        AnkaraSigorta: {
          image: require('@/assets/company-pages/ankara-sigorta.jpg')
        },
        AtlasMutuel: {
          image: require('@/assets/company-pages/atlas-sigorta.jpg')
        },
        MapfreSigorta: {
          image: require('@/assets/company-pages/mapfre-sigorta.jpg')
        },
        FibaEmeklilik: {
          image: require('@/assets/company-pages/fiba-emeklilik.jpg')
        },
        QuickSigorta: {
          image: require('@/assets/company-pages/quick-sigorta.jpg')
        },
        RaySigorta: {
          image: require('@/assets/company-pages/ray-sigorta.jpg')
        },
        HdiSigorta: {
          image: require('@/assets/company-pages/hdi-sigorta.jpg')
        },
        GeneraliSigorta: {
          image: require('@/assets/company-pages/generali-sigorta.jpg')
        },
        GroupamaSigorta: {
          image: require('@/assets/company-pages/groupama-sigorta.jpg')
        },
        DemirSigorta: {
          image: require('@/assets/company-pages/demir-sigorta.jpg')
        },
        AxaSigorta: {
          image: require('@/assets/company-pages/axa-sigorta.jpg')
        },
        UnicoSigorta: {
          image: require('@/assets/company-pages/unico-sigorta.jpg')
        },
        ZurichSigorta: {
          image: require('@/assets/company-pages/zurich-sigorta.jpg')
        },
        BereketSigorta: {
          image: require('@/assets/company-pages/bereket-sigorta.jpg')
        }
      },
      buttons: [
        {
          id: 1,
          title: 'KASKO SİGORTASI TEKLİFİ AL',
          class: 'brand--btn--icons fas fa-car-crash fa-2x mr-2'
        },
        {
          id: 2,
          title: 'TRAFİK SİGORTASI TEKLİFİ AL',
          class: 'brand--btn--icons fas fa-car fa-2x mr-2'
        },
        {
          id: 3,
          title: 'SAĞLIK SİGORTASI TEKLİFİ AL',
          class: 'brand--btn--icons fas fa-heartbeat fa-2x mr-2'
        }
      ]
    }
  },
  computed: {
    headerImg () {
      const routeName = this.$route.name
      return this.headers[routeName].image
    },
    textColor () {
      if (
        this.$route.name === 'AkSigorta' ||
        this.$route.name === 'GroupamaSigorta' ||
        this.$route.name === 'FibaEmeklilik'
      ) {
        return '#fff'
      } else return '#224099'
    }
  }
}
</script>

<style></style>
